import { IApiSmpGptAgent } from "@smp/api/src/smp/gpt/agent/agent.types";
import { DeepNonNullable } from "@smp/utils";

export const INITIAL_AGENT_PARAMS_POST: DeepNonNullable<
  IApiSmpGptAgent["params"]
>["post"] = {
  text_length: "medium",
  text_style: ["normal"],
  extra_fields: [],
  frameworks: ["random"],
  num: 3,
  language: "ru",
  topic: "",
};
